import React from "react";
import { Box, Button, Typography, Container } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const Hub = () => {
  const theme = useTheme();
  return (
    <Container
      disableGutters={useMediaQuery(theme.breakpoints.down("md"))}
      maxWidth="xl"
    >
      <Box
        sx={{
          display: "flex",
          padding: { xs: "24px", lg: "0 24px" },
          alignItems: { xs: "center", lg: "top" },
          flexDirection: { xs: "column-reverse", lg: "row" },
        }}
      >
        <Box>
          <Typography
            variant="h2"
            component="p"
            sx={{
              fontStyle: "italic",
              fontWeight: 700,
              mt: 4,
            }}
          >
            Working to Eliminate Empty Miles
          </Typography>
          <Typography variant="body1" component="p" sx={{ mt: 3 }}>
            We are a global organization that ensures consistent capacity with
            sustainable solutions for our carriers.
          </Typography>
          <Button
            variant="contained"
            disableElevation
            sx={{ my: 3 }}
            href="/eu/contact"
          >
            Join Our Network
          </Button>
        </Box>
        <Box
          component="img"
          src="/eu-assets/hub-6.webp"
          alt="map"
          sx={{
            width: "100%",
            maxWidth: "896px",
            height: "auto",
            mb: 5,
          }}
        />
      </Box>
    </Container>
  );
};

export default Hub;
